import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-progress-loading',
  templateUrl: './progress-loading.component.html',
  styleUrls: ['./progress-loading.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule]
})
export class ProgressLoadingComponent implements OnInit, OnDestroy, OnChanges{
  @Input() duration: number = 10;
  @Input() hasData: boolean = false;
  @Input() reset: boolean = false;

  isLoading: boolean = true;
  lights: string[] = ['gray', 'gray', 'gray', 'gray'];
  blinkingIndex: number | null = 0; 

  private intervalId: any;
  private blinkIntervalId: any;

  ngOnInit() {
    this.lights = ['gray', 'gray', 'gray', 'gray'];
    this.startLoading();
  }

  ngOnDestroy() {
    this.clearTimers();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['reset']?.firstChange == false) {
      this.ngOnDestroy();
      this.ngOnInit();
    }
  }

  startLoading() {
    const bufferTime = 1; 
    const adjustedTimeout = (this.duration - bufferTime) * 1000; // this allows to see the last point lit up
    const intervalTime = adjustedTimeout / 4;
    let currentLight = this.blinkingIndex = 0;

    this.startBlinking();

    this.intervalId = setInterval(() => {
      if (currentLight >= 4) {
        this.stopLoading();
        return;
      }

      this.lights[currentLight] = this.hasData ? 'green' : 'red';
      currentLight++;
      
      if (currentLight < 4) {
        this.blinkingIndex = currentLight;
      }
    }, intervalTime);
  }

  startBlinking() {
    let blinkState = false;

    this.blinkIntervalId = setInterval(() => {
      if (this.blinkingIndex !== null) {
        this.lights[this.blinkingIndex] = blinkState ? 'green' : 'red';
        blinkState = !blinkState;
      }
    }, 700);
  }

  stopLoading() {
    this.isLoading = false;
    this.clearTimers();
  }

  private clearTimers() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    if (this.blinkIntervalId) {
      clearInterval(this.blinkIntervalId);
      this.blinkIntervalId = null;
    }
  }
}
